"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Pete Arroyo",
  quote: "Anish was pivotal in guiding me through my first experience as a homeowner. Everything from finding me the best deal to giving me insight on all of the nuances of home ownership.",
  position: "Sold in Oswego"
}, {
  author: "Thaly Palanisamy",
  quote: "Anish is responsive and works with you to understand your needs and helps hone in on the perfect house.",
  position: "Sold in Naperville"
}];
export default function VoicesOfTheDiscerning() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226213" id="neighborhood-success-stories" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tight mb-6 text-foreground">What Clients Are Saying</h2>
          <div className="w-12 h-[2px] bg-primary"></div>
        </div>

        <div className="w-full max-w-6xl mx-auto relative">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-8">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-8 basis-[90%] md:basis-[75%] lg:basis-[60%]">
                  <div className="p-1">
                    <Card className="bg-card border border-border rounded-lg shadow-sm relative overflow-hidden group transition-all duration-500 hover:shadow-md">
                      <div className="absolute top-8 left-8 md:top-12 md:left-12 opacity-10 transition-opacity duration-500 group-hover:opacity-20">
                        <Quote className="w-16 h-16 md:w-24 md:h-24 text-primary" strokeWidth={1} />
                      </div>
                      <CardContent className="p-10 md:p-16 lg:p-20 flex flex-col items-center text-center relative z-10">
                        <blockquote className="mb-12 md:mb-16">
                          <p className="font-serif italic text-2xl md:text-3xl lg:text-4xl leading-relaxed text-foreground font-medium">
                            "{testimonial.quote}"
                          </p>
                        </blockquote>
                        <div className="mt-auto flex flex-col items-center space-y-2">
                          <div className="w-6 h-[2px] bg-primary mb-4"></div>
                          <cite className="not-italic font-default text-sm md:text-base tracking-wide text-foreground font-semibold">
                            {testimonial.author}
                          </cite>
                          <span className="font-default text-xs md:text-sm tracking-widest text-primary font-bold uppercase">
                            {testimonial.position}
                          </span>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="absolute -left-4 lg:-left-12 top-1/2 -translate-y-1/2 bg-background/80 backdrop-blur-sm border-border text-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-300 w-12 h-12 rounded-full flex items-center justify-center shadow-sm" />
              <CarouselNext className="absolute -right-4 lg:-right-12 top-1/2 -translate-y-1/2 bg-background/80 backdrop-blur-sm border-border text-foreground hover:bg-primary hover:text-primary-foreground transition-colors duration-300 w-12 h-12 rounded-full flex items-center justify-center shadow-sm" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}